import { Box, Grid } from '@mui/material';
import { AdminAuditLogEntry, AuditLogStats } from '../../../../types/admin';
import RefreshButton from '../../system/shared/RefreshButton';
import AuditLogTable from './AuditLogTable';
import AuditLogStatsCards from './AuditLogStatsCards';

interface AuditLogTabProps {
  auditLog: AdminAuditLogEntry[];
  auditLogStats: AuditLogStats;
  loading?: boolean;
  lastUpdated: string;
  onRefresh: () => void;
}

export default function AuditLogTab({
  auditLog,
  auditLogStats,
  loading,
  lastUpdated,
  onRefresh,
}: AuditLogTabProps) {
  return (
    <Box>
      {/* Header with Refresh Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        <RefreshButton onRefresh={onRefresh} lastUpdated={lastUpdated} loading={loading} />
      </Box>

      {/* Audit Log Stats */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <AuditLogStatsCards stats={auditLogStats} loading={loading} />
      </Grid>

      {/* Audit Log Table */}
      <AuditLogTable auditLog={auditLog} loading={loading} />
    </Box>
  );
}
